export const buttonSx = {
  color: '#121212',
};
